import {
  ADMIN_SENDER_STREAM_USER_IDS,
  EXCLUDE_INKLE_ADMIN_MESSAGES,
  EXCLUDE_SYSTEM_MESSAGES,
} from "constants/chatFilter";
import { MESSAGE_TYPE_SYSTEM } from "constants/chatType";
import { Channel } from "stream-chat";
import { DefaultStreamChatGenerics } from "stream-chat-react/dist/types/types";

export const isChannelLastMessageExcluded = (
  channel: Channel<DefaultStreamChatGenerics>,
  excludeOptions: string[]
) => {
  const lastMessage = channel.lastMessage();
  if (!lastMessage) {
    return false;
  }

  const isSystemMessage = lastMessage.type === MESSAGE_TYPE_SYSTEM;
  const isKnownAdminSender = Boolean(
    lastMessage.user?.id &&
      ADMIN_SENDER_STREAM_USER_IDS.includes(lastMessage.user.id)
  );
  const isInkleAdminMessage = isKnownAdminSender && !isSystemMessage;

  if (excludeOptions.includes(EXCLUDE_SYSTEM_MESSAGES) && isSystemMessage) {
    return true;
  }

  if (
    excludeOptions.includes(EXCLUDE_INKLE_ADMIN_MESSAGES) &&
    isInkleAdminMessage
  ) {
    return true;
  }

  return false;
};

export const filterExcludedChannels = (
  channels: Array<Channel<DefaultStreamChatGenerics>>,
  excludeOptions: string[]
) => {
  if (excludeOptions.length === 0) {
    return channels;
  }

  return channels.filter(
    (channel) => !isChannelLastMessageExcluded(channel, excludeOptions)
  );
};
